import { NgModuleRef } from '@angular/core';

import { TimeAndGeoipProvider } from '@fcom/core/services/time/time-geoip.provider';
import { GeolocationService } from '@fcom/core/services/geolocation/geolocation.service';
import { clientMonitoring, initClientMonitoring } from '@fcom/core/services/monitoring/monitoring-adapter.module';
import { parseGeolocationFromUrlHash } from '@fcom/dapi/utils/url-param.utils';
import { noop } from '@fcom/core/utils/utils';

import { ClientModule } from './app/client.module';
import { environment } from '../../environments/environment';

initClientMonitoring();

export const captureException = (error: unknown): void => clientMonitoring.captureException(error);

export const preInit = (module: NgModuleRef<ClientModule>): void => {
  const geoIpProvider: TimeAndGeoipProvider = module.injector.get(TimeAndGeoipProvider);
  const geolocationService: GeolocationService = module.injector.get(GeolocationService);

  geoIpProvider.triggerTimeAndGeoipFetch();
  geolocationService.init(parseGeolocationFromUrlHash());
};

export const init = (): (() => void) => {
  if (!environment.storageRoot) {
    const match = /storageRoot=(\w+)/.exec(window.location.search);
    window['storageRoot'] = match?.[1] || '';
  }

  return noop;
};
